import React, { useState, useEffect } from 'react'
import { Button, Input } from 'antd'

import 'antd/dist/antd.css'

export const getHost = () => {
  let host = new URL(window.location.href)
  if (host.hostname.startsWith('localhost')) {
    return 'stage'
  }
  return host.hostname.split('.')[0]
}

const DOMAINS = {
  vinissimus: 'vinissimus.com',
  fr: 'vinissimus.fr',
  italvinus: 'italvinus.it',
  de: 'hispavinus.de',
  uk: 'vinissimus.co.uk',
}

export const linkOrder = (provider, id_pedido) => {
  const [shop] = provider
  const host = getHost()
  return `https://${host}.${DOMAINS[shop]}/administracion/pedidos/detalle_pedido.html?id_pedido=${id_pedido}`
}

export const linkBackoffice = (shop, link) => {
  const host = getHost()
  return `https://${host}.${DOMAINS[shop]}${link}`
}

export function EditableField({
  label,
  defaultValue,
  onSave,
  editable = true,
  prefix,
  className,
  disabled: dis = true,
  onClick,
  children,
}) {
  const [value, setValue] = useState(defaultValue)
  const [disabled, setDisabled] = useState(dis)
  const disabledStyles = {
    backgroundColor: 'transparent',
    color: 'rgb(74, 74, 74)',
    border: '1px dashed rgb(217, 217, 217)',
  }
  const styles = { maxWidth: 300, ...(disabled ? disabledStyles : {}) }

  useEffect(() => setDisabled(dis), [dis])

  function click(e) {
    if (onClick) onClick(e)
    if (disabled) return setDisabled(false)
    if (onSave) onSave(value)
    setDisabled(true)
  }

  return (
    <div
      className={className}
      style={className ? {} : { padding: 10, display: 'flex' }}
    >
      <div style={{ paddingRight: 10, minWidth: 120 }}>
        {label ? `${label}:` : ''}
      </div>
      {children ? (
        children(disabled, setValue, styles)
      ) : (
        <Input
          onChange={(e) => setValue(e.target.value)}
          style={styles}
          defaultValue={defaultValue}
          prefix={prefix}
          disabled={disabled}
        />
      )}
      {editable && (
        <Button onClick={click} type={disabled ? 'default' : 'primary'}>
          {disabled ? 'Edit' : 'Save'}
        </Button>
      )}
    </div>
  )
}
